import React from 'react';
import { TouchableOpacity, View, StyleSheet } from 'react-native';
import CustomText from '../customText/CustomText';
import theme from '../../constants/theme.style.js';
import ProfileAvatarBackground from '../profileAvatar/ProfileAvatarBackground';

const styles = StyleSheet.create({
  messageContainer: {
    padding: 0,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    textAlign: 'left',
    backgroundColor: theme.GREY_LIGHT_COLOR,
    marginLeft: theme.CONTAINER_MARGIN,
    marginRight: theme.CONTAINER_MARGIN,
    marginTop: 15,
    borderRadius: 15,
    height: 70,
  },
  messageContainerUnread: {
    backgroundColor: '#5BA8A0',
    marginRight: 30,
  },
  messageImageContainer: {
    width: 70,
    height: 70,
    borderRadius: 15,
    marginRight: 10,
    backgroundColor: '#d6e8d2',
    justifyContent: 'center',
    alignItems: 'center',
  },
  messageImage: {
    height: 70,
    width: 70,
    borderRadius: 15,
  },
  messageInfo: {
    flex: 1,
    display: 'flex',
    justifyContent: 'center',
    paddingTop: 5,
    paddingBottom: 5,
  },
  messageTitle: {
    fontWeight: theme.FONT_WEIGHT_BOLD,
    fontSize: theme.FONT_SIZE_REGULAR,
    color: theme.GREY_DARKER_COLOR,
    fontFamily: 'Nunito_Bold',
  },
  messageSender: {
    fontSize: theme.FONT_SIZE_SMALL,
    color: theme.GREY_MEDIUM_COLOR,
  },
  messageDate: {
    position: 'absolute',
    right: 10,
    bottom: 5,
    fontSize: theme.FONT_SIZE_SMALL,
    color: theme.GREEN_DARKER_COLOR,
  },
  messageTitleUnread: {
    color: theme.WHITE_COLOR,
  },
  messageTextUnread: {
    color: theme.GREY_LIGHT_COLOR,
  },
  badge: {
    position: 'absolute',
    top: 5,
    right: 10,
    color: theme.GREY_LIGHT_COLOR,
  },
  badgeHidden: {
    display: 'none',
  },
  box: {
    position: 'absolute',
    top: 0,
    right: -15,
    width: 5,
    height: 70,
    backgroundColor: theme.GREEN_DARKER_COLOR,
  },
  boxHidden: {
    display: 'none',
  },
});

const daysBetweenToday = (someDate) => {
  const today = new Date();
  const diffTime = today - someDate;
  const diffDays = diffTime / (1000 * 60 * 60 * 24);
  return diffDays;
};

export default function MessageListItem({
  id,
  sender,
  recipient,
  title,
  read,
  date,
  navigation,
  onMessagePress,
  onMessageDisplay,
  userId,
  isInbox,
}) {
  let dateFromated = new Date(date);
  if (daysBetweenToday(dateFromated) < 0) {
    dateFromated = `${`0${dateFromated.getDate()}`.slice(-2)}/${`0${
      dateFromated.getMonth() + 1
    }`.slice(-2)}/${dateFromated.getFullYear()}`;
  } else if (daysBetweenToday(dateFromated) < 1) {
    dateFromated = 'Today';
  } else if (daysBetweenToday(dateFromated) < 2) {
    dateFromated = 'Yesterday';
  } else if (daysBetweenToday(dateFromated) < 7) {
    const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    dateFromated = days[dateFromated.getDay()];
  } else {
    dateFromated = `${`0${dateFromated.getDate()}`.slice(-2)}/${`0${
      dateFromated.getMonth() + 1
    }`.slice(-2)}/${dateFromated.getFullYear()}`;
  }

  async function messagePressHandler() {
    if (isInbox) {
      await onMessagePress(id);
      onMessageDisplay(userId);
    }
    navigation.navigate('InboxDetail', {
      id,
      isInbox,
    });
  }

  const avatar = isInbox ? sender.avatar : recipient.avatar;

  const text = isInbox
    ? `by ${sender.firstname} @ ${sender.nickname}`
    : `to ${recipient.firstname} @ ${recipient.nickname}`;

  return (
    <TouchableOpacity
      testID="callbacktest"
      style={
        read ? styles.messageContainer : [styles.messageContainer, styles.messageContainerUnread]
      }
      onPress={() => messagePressHandler()}
    >
      <View style={styles.messageImageContainer}>
        <ProfileAvatarBackground avatar={avatar} style={styles.messageImage} />
      </View>
      <View style={styles.messageInfo}>
        <CustomText
          testID="title"
          style={read ? styles.messageTitle : [styles.messageTitle, styles.messageTitleUnread]}
        >
          {title}
        </CustomText>
        <CustomText
          style={read ? styles.messageSender : [styles.messageSender, styles.messageTextUnread]}
        >
          {text}
        </CustomText>
      </View>
      {/* eslint-disable-next-line max-len */}
      <CustomText
        style={read ? styles.messageDate : [styles.messageDate, styles.messageTextUnread]}
      >
        {dateFromated}
      </CustomText>
      <View style={read ? [styles.box, styles.boxHidden] : styles.box} />
      <CustomText style={read ? [styles.badge, styles.badgeHidden] : styles.badge}>
        unread
      </CustomText>
    </TouchableOpacity>
  );
}
